import DownloadTickets from './DownloadTickets';

export default DownloadTickets;
